import React, { useEffect, useState } from 'react';
import { Feed, LeftSide } from '../../components';
import Greetings from '../../components/Greetings';

const Home = () => {
  return (
    <div className="home-container min-w-0 w-full">
      <Feed />
    </div>
  )
}

export default Home;